<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>

<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="玉山監控">
    <section class="stkpq19-panel">
      <mat-toolbar class="h-9 stkpq19-toolbar">
        <button class="btn" [class.btn-primary]="true" (click)="doStartSchedule()" [disabled]="isBusy || scheduleStatus?.isRunning">
          <mat-icon fontIcon="play_arrow"></mat-icon>啟動排程
        </button>
        <button class="btn" [class.btn-second]="true" (click)="doStopSchedule()" [disabled]="isBusy || !scheduleStatus?.isRunning">
          <mat-icon fontIcon="stop"></mat-icon>停止排程
        </button>
        <button class="btn" [class.btn-second]="true" (click)="refreshScheduleStatus()" [disabled]="isBusy">
          <mat-icon fontIcon="refresh"></mat-icon>更新狀態
        </button>
      </mat-toolbar>

      <div class="stkpq19-grid">
        <label class="stkpq19-field stkpq19-field-wide">
          <span>商品清單</span>
          <input
            type="text"
            [value]="filterOpt.symbolList"
            (input)="filterOpt.symbolList = $any($event.target).value"
            placeholder="留空時使用 esun-monitor.toml"
          />
        </label>

        <label class="stkpq19-field">
          <span>交易時段</span>
          <select [value]="filterOpt.session" (change)="filterOpt.session = $any($event.target).value">
            @for (item of sessionList; track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>
        </label>

        <label class="stkpq19-field">
          <span>短週期</span>
          <select [value]="filterOpt.shortTimeframe" (change)="filterOpt.shortTimeframe = $any($event.target).value">
            @for (item of timeframeList; track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>
        </label>

        <label class="stkpq19-field">
          <span>長週期</span>
          <select [value]="filterOpt.longTimeframe" (change)="filterOpt.longTimeframe = $any($event.target).value">
            @for (item of timeframeList; track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>
        </label>

        <label class="stkpq19-field">
          <span>短週期秒數</span>
          <input
            type="number"
            min="5"
            [value]="filterOpt.shortIntervalSeconds"
            (input)="filterOpt.shortIntervalSeconds = $any($event.target).valueAsNumber"
          />
        </label>

        <label class="stkpq19-field">
          <span>長週期秒數</span>
          <input
            type="number"
            min="5"
            [value]="filterOpt.longIntervalSeconds"
            (input)="filterOpt.longIntervalSeconds = $any($event.target).valueAsNumber"
          />
        </label>

        <label class="stkpq19-check">
          <input
            type="checkbox"
            [checked]="filterOpt.runImmediately"
            (change)="onRunImmediatelyChange($any($event.target).checked)"
          />
          <span>啟動後立即執行</span>
        </label>
      </div>

      <div class="stkpq19-status" [class.stkpq19-running]="scheduleStatus?.isRunning">
        <div class="stkpq19-status-title">
          排程狀態：{{ scheduleStatus?.isRunning ? '執行中' : '停止' }}
        </div>
        <textarea readonly [value]="scheduleStatusText"></textarea>
      </div>
    </section>

    <section class="stkpq19-panel">
      <mat-toolbar class="h-9 stkpq19-toolbar">
        <button class="btn" [class.btn-primary]="true" (click)="doStartStockSchedule()" [disabled]="isBusy || stockScheduleStatus?.isRunning">
          <mat-icon fontIcon="play_arrow"></mat-icon>啟動股票排程
        </button>
        <button class="btn" [class.btn-second]="true" (click)="doStopStockSchedule()" [disabled]="isBusy || !stockScheduleStatus?.isRunning">
          <mat-icon fontIcon="stop"></mat-icon>停止股票排程
        </button>
        <button class="btn" [class.btn-second]="true" (click)="refreshStockScheduleStatus()" [disabled]="isBusy">
          <mat-icon fontIcon="refresh"></mat-icon>股票狀態
        </button>
      </mat-toolbar>

      <div class="stkpq19-grid">
        <label class="stkpq19-field stkpq19-field-wide">
          <span>股票清單</span>
          <input
            type="text"
            [value]="filterOpt.stockSymbolList"
            (input)="filterOpt.stockSymbolList = $any($event.target).value"
            placeholder="留空時使用 esun-monitor.toml"
          />
        </label>

        <label class="stkpq19-field">
          <span>短週期</span>
          <select [value]="filterOpt.stockShortTimeframe" (change)="filterOpt.stockShortTimeframe = $any($event.target).value">
            @for (item of timeframeList; track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>
        </label>

        <label class="stkpq19-field">
          <span>長週期</span>
          <select [value]="filterOpt.stockLongTimeframe" (change)="filterOpt.stockLongTimeframe = $any($event.target).value">
            @for (item of timeframeList; track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>
        </label>

        <label class="stkpq19-field">
          <span>短週期秒數</span>
          <input
            type="number"
            min="5"
            [value]="filterOpt.stockShortIntervalSeconds"
            (input)="filterOpt.stockShortIntervalSeconds = $any($event.target).valueAsNumber"
          />
        </label>

        <label class="stkpq19-field">
          <span>長週期秒數</span>
          <input
            type="number"
            min="5"
            [value]="filterOpt.stockLongIntervalSeconds"
            (input)="filterOpt.stockLongIntervalSeconds = $any($event.target).valueAsNumber"
          />
        </label>

        <label class="stkpq19-check">
          <input
            type="checkbox"
            [checked]="filterOpt.stockRunImmediately"
            (change)="onStockRunImmediatelyChange($any($event.target).checked)"
          />
          <span>啟動後立即執行</span>
        </label>
      </div>

      <div class="stkpq19-status" [class.stkpq19-running]="stockScheduleStatus?.isRunning">
        <div class="stkpq19-status-title">
          股票排程狀態：{{ stockScheduleStatus?.isRunning ? '執行中' : '停止' }}
        </div>
        <textarea readonly [value]="stockScheduleStatusText"></textarea>
      </div>
    </section>

    <section class="stkpq19-panel">
      <mat-toolbar class="stkpq19-toolbar stkpq19-config-toolbar">
        <label class="stkpq19-config-select">
          <span>設定檔</span>
          <select [value]="selectedConfigFile" (change)="onConfigFileChange($any($event.target).value)">
            @for (item of configFileList; track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>
        </label>
        <button class="btn" [class.btn-second]="true" (click)="doLoadConfigFile()">
          <mat-icon fontIcon="folder_open"></mat-icon>讀取
        </button>
        <button class="btn" [class.btn-primary]="true" (click)="doSaveConfigFile()">
          <mat-icon fontIcon="save"></mat-icon>儲存
        </button>
      </mat-toolbar>

      <div class="stkpq19-path">{{ configFilePath }}</div>
      <textarea
        class="stkpq19-editor"
        [value]="configText"
        (input)="onConfigTextInput($any($event.target).value)"
        spellcheck="false"
      ></textarea>
    </section>

    <section class="stkpq19-panel">
      <div class="stkpq19-panel-title">API 回傳</div>
      <textarea class="stkpq19-message" readonly [value]="apiMessage"></textarea>
    </section>
  </mat-tab>
  <mat-tab #myTabDetail label="取得商品資料">
    <section class="stkpq19-panel">
      <mat-toolbar class="h-9 stkpq19-toolbar">
        <button class="btn" [class.btn-primary]="true" (click)="getTickers()" [disabled]="isBusy">
          <mat-icon fontIcon="search"></mat-icon>取得商品資料
        </button>
        <span class="stkpq19-ticker-status">{{ tickerStatusText }}</span>
      </mat-toolbar>

      <div class="stkpq19-grid">
        <label class="stkpq19-field">
          <span>商品類型</span>
          <select [value]="filterOpt.tickerType" (change)="onTickerTypeChange($any($event.target).value)">
            @for (item of tickerTypeList; track item.id) {
              <option [value]="item.id">{{ item.name }}</option>
            }
          </select>
        </label>

        <label class="stkpq19-field">
          <span>交易所</span>
          @if (isFutureTickerType()) {
            <select [value]="filterOpt.tickerExchange" (change)="filterOpt.tickerExchange = $any($event.target).value">
              @for (item of tickerFutureExchangeList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          } @else {
            <select [value]="filterOpt.tickerExchange" (change)="filterOpt.tickerExchange = $any($event.target).value">
              @for (item of tickerExchangeList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          }
        </label>

        @if (isFutureTickerType()) {
          <label class="stkpq19-field">
            <span>交易時段</span>
            <select [value]="filterOpt.tickerSession" (change)="filterOpt.tickerSession = $any($event.target).value">
              @for (item of sessionList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          </label>

          <label class="stkpq19-field">
            <span>商品代碼</span>
            <input
              type="text"
              [value]="filterOpt.tickerProduct"
              (input)="filterOpt.tickerProduct = $any($event.target).value"
            />
          </label>

          <label class="stkpq19-field">
            <span>契約類型</span>
            <select [value]="filterOpt.tickerContractType" (change)="filterOpt.tickerContractType = $any($event.target).value">
              @for (item of tickerContractTypeList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          </label>
        } @else {
          <label class="stkpq19-field">
            <span>市場別</span>
            <select [value]="filterOpt.tickerMarket" (change)="filterOpt.tickerMarket = $any($event.target).value">
              @for (item of tickerMarketList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          </label>

          <label class="stkpq19-field">
            <span>產業</span>
            <input
              type="text"
              [value]="filterOpt.tickerIndustry"
              (input)="filterOpt.tickerIndustry = $any($event.target).value"
            />
          </label>

          <label class="stkpq19-field">
            <span>正常交易</span>
            <select [value]="filterOpt.tickerIsNormal" (change)="filterOpt.tickerIsNormal = $any($event.target).value">
              @for (item of tickerBoolList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          </label>

          <label class="stkpq19-field">
            <span>注意股票</span>
            <select [value]="filterOpt.tickerIsAttention" (change)="filterOpt.tickerIsAttention = $any($event.target).value">
              @for (item of tickerBoolList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          </label>

          <label class="stkpq19-field">
            <span>處置股票</span>
            <select [value]="filterOpt.tickerIsDisposition" (change)="filterOpt.tickerIsDisposition = $any($event.target).value">
              @for (item of tickerBoolList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          </label>

          <label class="stkpq19-field">
            <span>暫停交易</span>
            <select [value]="filterOpt.tickerIsHalted" (change)="filterOpt.tickerIsHalted = $any($event.target).value">
              @for (item of tickerBoolList; track item.id) {
                <option [value]="item.id">{{ item.name }}</option>
              }
            </select>
          </label>
        }
      </div>
    </section>

    <app-jkgridwin #tickerGrid
      (afterGridReady)="afterTickerGridReady($event)"></app-jkgridwin>
  </mat-tab>

  <mat-tab #myTabDetail label="詳細資料">
    <mat-toolbar class="h-9">
      <button class="btn" [class.btn-primary]="true" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
    </mat-toolbar>
    <app-jkgridwin #jkgridwin
      (afterGridReady)="afterGridReady($event)"></app-jkgridwin>
  </mat-tab>
</mat-tab-group>
